import React from 'react';
import { connect } from 'react-redux';
import { Line } from 'react-lineto';
import ChildNodes from './ChildNodes'
import BaseNode from './BaseNode'
import SignUpBaseNode from '../SignupLogin/SignUpBaseNode'
import { parentNumber } from '../../common/node'

const Node = props => {
  let { id, number, client, server, x, y, root, page } = props
  if(!(number in client.status) || client.status[number]==='closed') {
    if(server.contents && server.contents[id]) {
      return(
        <div>
          <Line x0={x+75} y0={y+75} x1={client.x[parentNumber(number)]+75} y1={client.y[parentNumber(number)]+75}
            border='1px solid #D5D5D5' zIndex={-1} />
          { ( (id.indexOf('sign_up.')===0) || (id.indexOf('login.')===0) )
              ? (
                <SignUpBaseNode id={id} number={number} x={x || client.x[number]} y={y || client.y[number]} />
              )
              : (
                <BaseNode id={id} number={number} x={x || client.x[number]} y={y || client.y[number]} page={page} />
              )
          }
        </div>
      )
    } else {
      return( null )
    }
  }
  return (
    <div>
      <ChildNodes parent={number} id={id} root={root} page={page} />
      <BaseNode id={id} number={number} x={client.x[number]} y={client.y[number]} root={root} page={page} />
    </div>
  )
}


const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

export default connect(mapStateToProps)(Node);



// WEBPACK FOOTER //
// ./src/components/nodes/Node.js